// extracted by mini-css-extract-plugin
module.exports = {"pending":"Pending_pending__3BDCM"};